import C from "../constants";
import { format, isValid } from "date-fns";
import * as api from "../api/generated-api";
import ShortUniqueId from "short-unique-id";

export const isEmpty = (input: string): boolean => {
  return input === undefined || input === null || input.trim() === "";
};

export const formatDate = (date: Date) => {
  if (date && isValid(date)) {
    return format(date, "LLLL d, yyyy");
  }
  return "";
};

export const abbreviateNumber = (number: number): string => {
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    notation: "compact",
    compactDisplay: "short",
  }).format(number);
};

export const toValidIdentifier = (value: string): string => {
  return value.replaceAll(/\s+/g, "_").replaceAll(/[^-:.\w+]/g, "_");
};

export const isCompanyMember = (personRole: number): boolean => {
  return [
    C.ACCOUNT_ADMIN_ROLE,
    C.FORM_ADMIN_ROLE,
    C.USER_ROLE,
    C.USER_COMPANY_MEMBER_ROLE,
  ].includes(personRole);
};

type OrganizationPerson = {
  organization_id?: number;
  person_id: number;
  role_id: number;
};

type OrganizationPersons = OrganizationPerson[];

export const isCompanyMemberOrCounselForDeal = (
  organizationPersons: OrganizationPersons,
  orgId: number,
  dealId: number,
  dealLegalEntitiesForUser: api.DealLegalEntity[]
): boolean => {
  const foundOrganizationPerson = organizationPersons.find(
    (organizationPerson) => organizationPerson.organization_id == orgId
  );

  let companyMember = false;

  if (foundOrganizationPerson) {
    companyMember = isCompanyMember(foundOrganizationPerson.role_id);
  }

  if (!companyMember && dealLegalEntitiesForUser) {
    const companyMemberOrLawyer = dealLegalEntitiesForUser.filter((dle) => {
      if (
        dle.legalEntityType === api.LegalEntityType.Company_Counsel ||
        dle.legalEntityType === api.LegalEntityType.Board_Member ||
        dle.legalEntityType === api.LegalEntityType.Chief_Executive_Officer ||
        dle.legalEntityType === api.LegalEntityType.Key_Common_Holder ||
        dle.legalEntityType === api.LegalEntityType.Secretary
      ) {
        return dle.dealId == dealId;
      }
    });
    companyMember = !!companyMemberOrLawyer.length;
  }

  return companyMember;
};

export const isInvestorInAtLeastOneOrg = (
  organizationPersons: OrganizationPersons
): boolean => {
  const matchingOrgPersons = organizationPersons.filter((orgPerson) => {
    if (orgPerson.role_id === C.USER_MEMBER_ROLE) {
      return orgPerson;
    }
  });

  return matchingOrgPersons && !!matchingOrgPersons.length;
};

export const isInvestorMemberInInvestorOrg = (
  organizationPersons: OrganizationPersons,
  investor: api.DealInvestor
): boolean => {
  const investorOrgId = investor.investorOrganizationId;
  const matchingOrgPersons = organizationPersons.filter((orgPerson) => {
    if (orgPerson.organization_id === investorOrgId) {
      return orgPerson;
    }
  });

  return matchingOrgPersons && !!matchingOrgPersons.length;
};

export const uid = new ShortUniqueId({
  length: 8,
  dictionary: "alphanum_lower",
});

export const getDisplayNameForLegalEntityType = (
  legalEntityType: api.LegalEntityType
) => {
  api.LegalEntityType;
  if (legalEntityType === api.LegalEntityType.Investor_Investment) {
    return "Investor";
  } else {
    return legalEntityType;
  }
};
